import api from './core';
import { Outlet, OutletDetail, CreateOutletRequest, UpdateOutletRequest } from './types';
import { normalizePaginatedResponse, type PaginatedResponse } from './pagination';

const MAX_PAGE_SIZE = 200;

export const getOutlets = async (
  filters?: {
    site_id?: string | number;
    address_id?: string | number;
    floor_id?: string | number;
    room_id?: string | number;
    network_id?: string | number;
    name?: string;
    description?: string;
    room_name?: string;
    network_name?: string;
    limit?: number;
    offset?: number;
  } | any,
  signal?: AbortSignal
): Promise<PaginatedResponse<Outlet>> => {
  const params = new URLSearchParams();

  const actualFilters = filters && filters.queryKey ? filters.queryKey[1] : filters;

  if (actualFilters?.site_id) params.append('site_id', String(actualFilters.site_id));
  if (actualFilters?.address_id) params.append('address_id', String(actualFilters.address_id));
  if (actualFilters?.floor_id) params.append('floor_id', String(actualFilters.floor_id));
  if (actualFilters?.room_id) params.append('room_id', String(actualFilters.room_id));
  if (actualFilters?.network_id) params.append('network_id', String(actualFilters.network_id));
  if (actualFilters?.name) params.append('name', String(actualFilters.name));
  if (actualFilters?.description) params.append('description', String(actualFilters.description));
  if (actualFilters?.room_name) params.append('room_name', String(actualFilters.room_name));
  if (actualFilters?.network_name) params.append('network_name', String(actualFilters.network_name));

  const limit = Math.min(Number(actualFilters?.limit) || MAX_PAGE_SIZE, MAX_PAGE_SIZE);
  const offset = Number(actualFilters?.offset) || 0;
  params.set('limit', String(limit));
  params.set('offset', String(offset));

  const queryString = params.toString();
  const url = queryString ? `/crm/outlets/?${queryString}` : '/crm/outlets/';
  const response = await api.get(url, { signal });
  return normalizePaginatedResponse(response.data);
};

export const getOutlet = async (
  outletId: string | number,
  signal?: AbortSignal
): Promise<OutletDetail> => {
  const response = await api.get(`/crm/outlets/${outletId}/`, { signal });
  return response.data;
};

export const createOutlet = async (data: CreateOutletRequest): Promise<Outlet> => {
  const response = await api.post('/crm/outlets/', data);
  return response.data;
};

export const updateOutlet = async (outletId: string | number, data: UpdateOutletRequest): Promise<Outlet> => {
  const response = await api.patch(`/crm/outlets/${outletId}/`, data);
  return response.data;
};

export const deleteOutlet = async (outletId: string | number): Promise<void> => {
  await api.delete(`/crm/outlets/${outletId}/`);
};
